import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import { pageTitle } from '../../helpers/PageTitle';
import { Link } from 'react-router-dom';

export default function Portfolio3() {
  pageTitle('Kiambu County - Street Lighting Project');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Solar Street Lighting Installation"
        subTitle="County Infrastructure"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="cs_portfolio_details">
          <img src="/images/portfolio/Street-light-1.jpg" alt="Street Lighting" />
          <Spacing lg="100" md="40" />
          <div className="cs_portfolio_details_in">
            <ul className="cs_portfolio_details_info cs_mp0">
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Client Type:</h3>
                <p className="mb-0">County Government</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
                <p className="mb-0">Kiambu County</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Duration:</h3>
                <p className="mb-0">3 Months</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">
                  Project Completed:
                </h3>
                <p className="mb-0">February 2024</p>
              </li>
            </ul>
            <div className="cs_portfolio_details_right">
              <h2>Project Summary</h2>
              <p>
                A large-scale street lighting project that enhanced public safety and urban development in Kiambu County. The project involved installing solar-powered LED street lights across major roads and public spaces.
                <br />
                This sustainable lighting solution has significantly improved nighttime visibility and security while eliminating electricity costs for the county.
              </p>
              <p>
                Project Highlights:
              </p>
              <ul>
                <li>200+ solar street lights installed</li>
                <li>Smart lighting control system</li>
                <li>Remote monitoring capabilities</li>
                <li>5-year maintenance plan</li>
                <li>Enhanced community safety</li>
              </ul>
            </div>
          </div>
          <Spacing lg="115" md="60" />
          <div className="cs_portfolio_details_gallery">
            <div>
              <img src="/images/portfolio/street-light-2.jpg" alt="Night View" />
            </div>
            <div>
              <img src="/images/portfolio/street-light-3.jpg" alt="Installation" />
            </div>
            <div>
              <img src="/images/portfolio/street-light-4.jpg" alt="Control Center" />
            </div>
          </div>
        </div>
        <Spacing lg="90" md="60" />
        <div className="cs_page_navigation cs_center">
          <div>
            <Link to="/portfolio/portfolio-2" className="cs_text_btn cs_type1">
              <Icon icon="cil:arrow-left" className="cs_fs_21" />
              <span>Prev Project</span>
            </Link>
          </div>
          <div>
            <Link to="/portfolio/portfolio-4" className="cs_text_btn">
              <span>Next Project</span>
              <Icon icon="cil:arrow-right" className="cs_fs_21" />
            </Link>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
} 